module.exports = __webpack_public_path__ + "static/media/university-of-washington.e5914245.png";